import clsx from 'clsx';
import React, { memo } from 'react';
import { useCartContext } from '@srcDS/provider/cart/CartContext';
import styles from './CartButton.module.scss';
import Button from '@srcDS/components/atoms/button';
import { ShoppingCard } from '@srcDS/components/atoms/icons';

interface CartButtonProps {
  isInvertedClass?: string;
  placement?: string;
  iconStyles?: React.CSSProperties;
  isMobile?: boolean;
}

interface CartItem {
  count?: number;
}

interface CartData {
  cart?: {
    lineItems?: CartItem[];
  };
}

export const CartButton = memo<CartButtonProps>(({
  isInvertedClass,
  placement,
  iconStyles,
  isMobile,
}) => {
  const { cartData, setShowCart } = useCartContext();

  const getCartItemsCount = (cartData: CartData): number => {
    const items = cartData?.cart?.lineItems || [];
    return items.reduce((total: number, item: CartItem) => total + (item.count || 0), 0);
  };

  const cartItemsCount = getCartItemsCount(cartData);
  return (
    // @ts-ignore
    <Button
      variant="primary"
      as="text"
      onClick={() => setShowCart(true)}
      ariaLabel="Cart"
      data-cart-icon={isMobile ? 'cart_icon_mob' : 'cart_icon_desk'}
      className={clsx(
        styles.button,
        placement && styles[`placement_${placement}`],
        isInvertedClass,
      )}
    >
      <ShoppingCard style={iconStyles} />
      {cartItemsCount > 0 && <span className={styles.cartCountText}>{cartItemsCount}</span>}
    </Button>
  );
});